import { BACKEND_URL } from '../../configs';
import { CONNECTION_ERROR } from '../../configs/serverStatusCodes';

export const MODULE_UNAVAILABLE_MESSAGE = 'Модуль недоступен';
export const MODULE_UNAVAILABLE_DESCRIPTION = 'Нет подключения к сервису модуля.';

export const SERVICE_KEYS = {
  SUBSCRIPTION: 'subscriptionService',
  SESSION_LOG: 'sessionLogService',
  PAYMENT: 'paymentService',
  CLIENTS: 'clientsService',
  REPORTS: 'reportsService',
  ZONES: 'zonesService',
  TARIFF: 'tariffService',
  SUBSCRIPTION_BLACK_WHITE: 'subscriptionBlackWhiteService',
  EVENT_LOG: 'eventLogService',
  HOSTS: 'hostsService',
  SERVICE_MONITORING: 'serviceMonitoringService',
  USER_ACTION_LOG: 'userActionLogService',
};

export const SERVICE_HEALTH_CHECKS = {
  [SERVICE_KEYS.SUBSCRIPTION]: {
    method: 'GET',
    url: `${BACKEND_URL}/proxy/subscription/v1/subscriptions`,
    params: { page: 1, limit: 1 },
  },
  [SERVICE_KEYS.SESSION_LOG]: {
    method: 'GET',
    url: `${BACKEND_URL}/sessions`,
    params: { page: 1, limit: 5 },
  },
  [SERVICE_KEYS.PAYMENT]: {
    method: 'GET',
    url: `${BACKEND_URL}/payments`,
    params: { page: 1, limit: 5 },
  },
  [SERVICE_KEYS.CLIENTS]: {
    method: 'GET',
    url: `${BACKEND_URL}/clients`,
    params: { page: 1, limit: 1 },
  },
  [SERVICE_KEYS.REPORTS]: {
    method: 'GET',
    url: `${BACKEND_URL}/proxy/report/v1/reports`,
    params: { page: 1, limit: 1 },
  },
  [SERVICE_KEYS.ZONES]: {
    method: 'GET',
    url: `${BACKEND_URL}/proxy/parking-registration/v1/parking_lots`,
    params: { page: 1, limit: 1 },
  },
  [SERVICE_KEYS.TARIFF]: {
    method: 'GET',
    url: `${BACKEND_URL}/proxy/tariff/v1/tariffs`,
    params: { page: 1, limit: 1 },
  },
  [SERVICE_KEYS.SUBSCRIPTION_BLACK_WHITE]: {
    method: 'GET',
    url: `${BACKEND_URL}/proxy/black-white/v1/blackwhites/`,
    params: { page: 1, limit: 1, type: 'BLACK' },
  },
  [SERVICE_KEYS.EVENT_LOG]: {
    method: 'GET',
    url: `${BACKEND_URL}/activities`,
    params: { page: 1, limit: 1 },
  },
  [SERVICE_KEYS.HOSTS]: {
    method: 'GET',
    url: `${BACKEND_URL}/hosts`,
    params: { page: 1, limit: 1 },
  },
  [SERVICE_KEYS.SERVICE_MONITORING]: {
    method: 'GET',
    url: `${BACKEND_URL}/services`,
    params: { page: 1, limit: 1 },
  },
  [SERVICE_KEYS.USER_ACTION_LOG]: {
    method: 'GET',
    url: `${BACKEND_URL}/user-activities`,
    params: { page: 1, limit: 1 },
  },
};

export const MENU_SERVICE_DEPENDENCIES = {
  'menu.service-monitoring': [SERVICE_KEYS.SERVICE_MONITORING],
  'menu.event-log': [SERVICE_KEYS.EVENT_LOG],
  'menu.user-action-log': [SERVICE_KEYS.USER_ACTION_LOG],
  'menu.hosts-page': [SERVICE_KEYS.HOSTS],
  'menu.hosts-directory-page': [SERVICE_KEYS.HOSTS],
  'menu.session-log': [SERVICE_KEYS.SESSION_LOG],
  'menu.payment-log': [SERVICE_KEYS.PAYMENT],
  'menu.clients': [SERVICE_KEYS.CLIENTS],
  'menu.reports-page': [SERVICE_KEYS.REPORTS],
  'menu.zones-page': [SERVICE_KEYS.ZONES],
  'menu.tariff': [SERVICE_KEYS.TARIFF],
  'menu.subscription': [SERVICE_KEYS.SUBSCRIPTION],
};

export const isServiceUnavailableStatus = status => (
  status === CONNECTION_ERROR
  || status === 404
  || status === 502
  || status === 503
  || status === 504
  || (typeof status === 'number' && status >= 500)
);

export const getServiceKeysByMenuNames = (menuNames = []) => {
  const keys = new Set();

  menuNames.forEach(menuName => {
    const dependencies = MENU_SERVICE_DEPENDENCIES[menuName] || [];
    dependencies.forEach(key => keys.add(key));
  });

  return [...keys];
};

export const getServiceAvailabilityItem = (serviceAvailability = {}, serviceKey) => (
  serviceAvailability[serviceKey] || { available: true, checked: false }
);

export const isServiceUnavailable = (serviceAvailability = {}, serviceKey) => {
  const item = getServiceAvailabilityItem(serviceAvailability, serviceKey);
  return Boolean(item.checked) && !item.available;
};

export const isMenuUnavailable = (serviceAvailability = {}, menuName) => {
  const dependencies = MENU_SERVICE_DEPENDENCIES[menuName] || [];
  if (!dependencies.length) {
    return false;
  }

  return dependencies.some(serviceKey => isServiceUnavailable(serviceAvailability, serviceKey));
};
